enum ActivityStatus {
  Scheduled = "Scheduled",
  Started = "Started",
  Finished = "Finished",
  Uncleaned = "Uncleaned",
  Cancelled = "Cancelled",
}

export default ActivityStatus;
